import { BaseControl } from "../base-control";

class RichtextControlCtrl extends BaseControl {
  constructor(BaseControlService, ScriptLoaderService, $scope, $element, $interval, $sce) {
    'ngInject';
    super(BaseControlService, $scope);
    Object.assign(this, {$element, $interval, $sce});
    this.sls = ScriptLoaderService;
  }

  afterInit() {
    super.afterInit();
    if (!this.isPrint) {
      this.$scope.$watch("$ctrl.enabled", _ => this.setReadOnlyHtml());
    }
  }

  modelChanged(newVal, oldVal) {
    super.modelChanged(newVal, oldVal);
    if (this.token.fieldSchema.isReadOnly) this.setReadOnlyHtml();
  }

  async initializeControlData() {
    await super.initializeControlData();
    if (this.isPrint || this.token.fieldSchema.isReadOnly) { 
      this.setReadOnlyHtml();
      this.destroyCkEditor();
    } else {
      await this.sls.waitForLibObject("CKEDITOR");
      this.$timeout(_ => this.configEditor());
    }
  }

  setReadOnlyHtml() {
    const html = this.isPrint ? this.model?.display : this.model?.value;
    this.readOnlyHtml = this.$sce.trustAsHtml((html || '').toString());
  }

  configEditor() {
    CKEDITOR.disableAutoInline = true;
    const config = {
      image_previewText: ' ',
      fillEmptyBlocks: false,
      fullPage: false,
      editorplaceholder: this.label,
      toolbarGroups: [
        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
        { name: 'links', groups: [ 'links' ] },
        { name: 'insert', groups: [ 'insert' ] },
        '/',
        { name: 'styles', groups: [ 'styles' ] },
        { name: 'colors', groups: [ 'colors' ] },
        { name: 'tools', groups: [ 'tools' ] },
        { name: 'others', groups: [ 'others' ] },
        { name: 'document', groups: [ 'mode' ] }
      ],
      removeButtons: 'About,BidiLtr,BidiRtl,Blockquote,Button,Checkbox,CopyFormatting,CreateDiv,ExportPdf,Flash,Form,HiddenField,Iframe,ImageButton,Language,Maximize,NewPage,Preview,Print,Radio,Select,ShowBlocks,Styles,Subscript,Superscript,Textarea,TextField',
      removePlugins: 'exportpdf',
      extraPlugins: 'sourcedialog'
    };

    let divElement = this.$interval(_ => {
      if ($(`#${this.token.id}-control`).length) {
        CKEDITOR.inline(
          `${this.token.id}-control`,{ ...CKEDITOR.config, ...config });
        this.$interval.cancel(divElement);
        divElement = undefined;
      }
    }, 300);
  }
  
  $onDestroy() {
    this.destroyCkEditor();
  }

  destroyCkEditor() {
    if (typeof CKEDITOR !== 'undefined') {
      CKEDITOR?.instances[`${this.token.id}-control`]?.destroy();
    }
  }
}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<"
  },
  templateUrl: "fe-control/controls/richtext-control/richtext-control.component.html",
  controller: RichtextControlCtrl
};